module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "center big-padding",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.errorCancellationMessage) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("\n      Ok\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5a039599!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/demande/ErrorModal.vue
// module id = 2107
// module chunks = 2